export enum APP_USER_PERMISSIONS {
	HM = 'HM',
	SCH = 'SCH',
	GE = 'GE',
	PW = 'PW'
}

export const PERMISSON_ALLOWED_KEY = 'permissionsAllowed';
export const PERMISSON_DENIED_KEY = 'permissionsDenied';
